import { AbstractControl } from '@angular/forms';

export class CustomValidator {
  /**
   * Validate password and confirm password matched.
   * @param control FormControl
   */
  static matchPassword(control: AbstractControl) {
    return ((control.value.password && control.value.confirmPassword) &&
     control.value.password !== control.value.confirmPassword) ?
     control.get('confirmPassword').setErrors({ notMatch: true }) : null;
  }
}
